//Reset data
export const RESET = "NOTIFICATION_CREATE_RESET"

//Loading
export const SET_TOGGLE_LOADING = "NOTIFICATION_CREATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "NOTIFICATION_CREATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "NOTIFICATION_CREATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "NOTIFICATION_CREATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "NOTIFICATION_CREATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "NOTIFICATION_CREATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "NOTIFICATION_CREATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "NOTIFICATION_CREATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "NOTIFICATION_CREATE_SET_HIDE_MESSAGE"

//Data
export const SET_CREATED = "NOTIFICATION_CREATE_SET_CREATED"
export const SET_IS_CREATED = "NOTIFICATION_CREATE_SET_IS_CREATED"
export const SET_NOT_CREATED = "NOTIFICATION_CREATE_SET_NOT_CREATED"
export const SET_CURRENT_ITEM = "NOTIFICATION_CREATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "NOTIFICATION_CREATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "NOTIFICATION_CREATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "NOTIFICATION_CREATE_SET_HIDE_MODAL"


export const SET_MODAL = "NOTIFICATION_CREATE_SET_MODAL"
export const SET_MODAL_CONTENT = "NOTIFICATION_CREATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "NOTIFICATION_CREATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "NOTIFICATION_CREATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "NOTIFICATION_CREATE_SET_MODAL_TYPE"